import { createSelector, createFeatureSelector } from '@ngrx/store';
import { CheckoutState } from './checkout.reducer';

export const CHECKOUT_FEATURE_KEY = 'checkout';

const getCheckoutState = createFeatureSelector<CheckoutState>(CHECKOUT_FEATURE_KEY);

const getSelectedCreditBundle = createSelector(getCheckoutState, (state: CheckoutState) => state.selectedCreditBundle);

const getQuoteToSend = createSelector(getCheckoutState, (state: CheckoutState) => state.quoteToSend);

const getCreditBundles = createSelector(getCheckoutState, (state: CheckoutState) => state.creditBundles);

const getCards = createSelector(getCheckoutState, (state: CheckoutState) => state.cards);

const getSpecialCreditBundle = createSelector(getCheckoutState, (state: CheckoutState) => state.specialCreditBundle);

export const checkoutQuery = {
  getSelectedCreditBundle,
  getSpecialCreditBundle,
  getCreditBundles,
  getQuoteToSend,
  getCards
};
